import type { Application } from 'pixi.js';
import { Container } from 'pixi.js';
import type { AllProps } from './props';
import props from './props';
import type { Preload } from '../../app/loader/Preload';

export default function initPropMixins(pixi: Application, preloader: Preload): void {
  Container.mixin({
    props(propsData: AllProps) {
      return props(this as Container, propsData);
    },
    get pixi(): Application {
      return pixi;
    },
    get preloader(): Preload {
      return preloader;
    },
    set scaleX(value: number) {
      (this as Container).scale.x = value;
    },
    get scaleX(): number {
      return (this as Container).scale.x;
    },
    set scaleXY(value: number) {
      if ((this as Container).destroyed) return;
      (this as Container).scale.set(value);
    },
    get scaleXY(): number {
      return (this as Container).scale.x;
    },
    set scaleY(value: number) {
      (this as Container).scale.y = value;
    },
    get scaleY(): number {
      return (this as Container).scale.y;
    },
    set pivotX(value: number) {
      (this as Container).pivot.x = value;
    },
    get pivotX(): number {
      return (this as Container).pivot.x;
    },
    set pivotY(value: number) {
      (this as Container).pivot.y = value;
    },
    get pivotY(): number {
      return (this as Container).pivot.y;
    },

    set anchorX(value: number) {
      if (!this.anchor) return;
      (this.anchor as { x: number }).x = value;
    },
    get anchorX(): number {
      if (!this.anchor) return 0;
      return (this.anchor as { x?: number }).x ?? 0;
    },
    set anchorY(value: number) {
      if (!this.anchor) return;
      (this.anchor as { y: number }).y = value;
    },
    get anchorY(): number {
      if (!this.anchor) return 0;
      return (this.anchor as { y?: number }).y ?? 0;
    },
  });
}
